import type { CartProductPhoto } from 'domains/cart_products';
import type { SavedArrangementCrop } from 'domains/saved_arrangements';
import type { Dimension } from 'types/common_types';
import type { ImageFilter, PhotoCrop } from 'types/photo_types';

export type CropsSliceInitialState = {
  activeNodeUid: string | null;
};

export type CropEntity = PhotoCrop & {
  id: string;
  canvasId: string;
  nodeUid: string;
  photoId: number;
  photoLoaded: boolean;
  blobSrc?: string;
  nodeAspectRatio?: number;
  fitCropW?: number;
  fitCropH?: number;
};

export type CreateCropPayload = {
  canvasId: string;
  photoId: number;
  nodeUid: string;
};

export type FetchCropPhotoPayload = CreateCropPayload & {
  blobSrc: string;
};

export type FetchCropPhotoFailedPayload = {
  canvasId: string;
  nodeUid: string;
};

export type CropDimensionsPayload = {
  canvasId: string;
  nodeUid: string;
  nodeDimension: Dimension;
  imageDimensions: Dimension;
};

export type RestoreCartProductPhoto = {
  crop: CartProductPhoto['crop'];
  filter: ImageFilter['filterType'];
  canvasId: string;
  uid: string;
  photoId: number;
};

export type RestoreArrangementCropsPayload = SavedArrangementCrop & {
  blobSrc: string;
};

export type PanCropPayload = {
  canvasId: string;
  nodeUid: string;
  /** Percent of scaled crop that we've panned in the X dimension */
  movementX: number;
  /** Percent of scaled crop that we've panned in the Y dimension */
  movementY: number;
  /** If the node has been rotated using transforms, the mouse panning direction is opposite */
  flipTrackingDirection: boolean;
};

export type ZoomCropPayload = {
  canvasId: string;
  zoom: number;
};

export type FilterCropPayload = {
  filter: ImageFilter;
  crop: CropEntity;
};

export type RotateCropPayload = {
  cropId: string;
  rotation: number;
  blobSrc: string;
};

export type CropPhotoLoadedPayload = {
  id: string;
  loaded: boolean;
};
